import axiosConfig from '../../config/axios';

export const sendPushTokenToServer = async payload => {
  const response = await axiosConfig.post('/push_tokens', payload);
  return response.data;
};
